import { useAuthenticatedUserQuery } from 'modules/auth/queries/useAuthenticatedUser.query'
import { useCorporateOfferQuery } from 'modules/corporate/queries/useCorporateOffer.query'
import { CorporateOffer } from 'modules/corporate/types/offers'
import React, { createContext, PropsWithChildren, useContext } from 'react'

interface CorporateOfferContextProps {
  corporateOffer?: CorporateOffer
  isLoading: boolean
  isError: boolean
  refetch: () => void
}

export const CorporateOfferContext = createContext<
  CorporateOfferContextProps | undefined
>(undefined)

const CorporateOfferContextProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const { data: authenticatedUser } = useAuthenticatedUserQuery()

  const {
    data: corporateOffer,
    isLoading,
    isError,
    refetch,
  } = useCorporateOfferQuery(authenticatedUser?.corporateId)

  return (
    <CorporateOfferContext.Provider
      value={{ corporateOffer, isLoading, isError, refetch }}
    >
      {children}
    </CorporateOfferContext.Provider>
  )
}

const useCorporateOfferContext = () => {
  const context = useContext(CorporateOfferContext)
  if (context === undefined) {
    throw new Error(
      'useCorporateOfferContext must be used within a CorporateOfferContextProvider'
    )
  }
  return context
}
export { CorporateOfferContextProvider, useCorporateOfferContext }
